import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SpendByLocationChart = ({ transactions }) => {
  // Group transactions by location
  const groupedData = transactions.reduce((acc, txn) => {
    const locationName = txn.location?.name || 'Unknown Location';

    if (!acc[locationName]) {
      acc[locationName] = {
        locationName,
        totalSpend: 0,
        transactionCount: 0
      };
    }

    acc[locationName].totalSpend += parseFloat(txn.amount || 0);
    acc[locationName].transactionCount += 1;

    return acc;
  }, {});

  // Convert to array, sort by total spend, and take top 10
  const chartData = Object.values(groupedData)
    .sort((a, b) => b.totalSpend - a.totalSpend)
    .slice(0, 10);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
          <p className="text-sm font-semibold text-gray-900">
            {payload[0].payload.locationName}
          </p>
          <p className="text-sm text-gray-700 mt-1">
            Total Spend: <span className="font-semibold">{formatCurrency(payload[0].value)}</span>
          </p>
          <p className="text-sm text-gray-600">
            Transactions: {payload[0].payload.transactionCount}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by Location (Top 10)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="locationName"
            tick={{ fontSize: 11, fill: '#6b7280' }}
            stroke="#9ca3af"
            angle={-45}
            textAnchor="end"
            height={80}
            interval={0}
          />
          <YAxis
            tickFormatter={formatCurrency}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            stroke="#9ca3af"
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="totalSpend"
            fill="#ec4899"
            name="Total Spend"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendByLocationChart;
